import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';
import { LocalStorageSettingsService } from './local-storage-settings.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {


    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(
      private http: HttpClient,
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService,
      private restAPI: RestApi,
      private localStorageSettings: LocalStorageSettingsService
    ) { }

    searchProducts(searchValue: string) {
       let UserId=this.localStorageSettings.getSettings("UserId");
      return this.http.get<any[]>(
        this.restAPI.GET_PRODUCTS_ON_SEARCH,
        {
          headers: this.headers,
          params: { search: searchValue,userId: UserId}
        }
      );
}

  searchSignals(searchValue: string) {
      return this.http.get<any[]>(
        this.restAPI.GET_SIGNALS_ON_SEARCH,
        {
          headers: this.headers,
          params: { search: searchValue}
        }
      );
}

    searchReviewActivity(searchValue: string) {
       let UserId=this.localStorageSettings.getSettings("UserId");
      return this.http.get<any[]>(
        this.restAPI.GET_REVIEW_ACTIVITY_ON_SEARCH,
        {
          headers: this.headers,
          params: { search: searchValue,userId: UserId}
        }
      );
}

  searchAlertRules(searchValue: string) {
      return this.http.get<any[]>(
        this.restAPI.GET_ALERT_RULE_ON_SEARCH,
        {
          headers: this.headers,
          params: { search: searchValue}
        }
      );
}



}
